import "../css/style.scss";

import Accordion from "./modules/Accordion";

import Accordion2 from "./modules/Accordion2";

import HeroSlider from "./modules/HeroSlider";

//for vedio banner

var ctrlVideo = document.getElementById("m-video");
console.log("tes");
jQuery(".m-button").click(function () {
  console.log("click");
  if (jQuery(".m-button").hasClass("active")) {
    ctrlVideo.play();
    jQuery(".m-button").toggleClass("active");
    jQuery(".m-banner-mob").toggleClass("active");
    jQuery(".m-button").toggleClass("hide");
  } else {
    ctrlVideo.pause();
    jQuery(".m-button").toggleClass("active");
    jQuery(".m-banner-mob").toggleClass("active");
    jQuery(".m-button").toggleClass("hide");
  }
});
jQuery(".m-banner-mob").click(function () {
  if (jQuery(".m-banner-mob").hasClass("active")) {
    ctrlVideo.play();
    jQuery(".m-banner-mob").toggleClass("active");
    jQuery(".m-button").toggleClass("active");
    jQuery(".m-button").toggleClass("hide");
  } else {
    ctrlVideo.pause();
    jQuery(".m-banner-mob").toggleClass("active");
    jQuery(".m-button").toggleClass("active");
    jQuery(".m-button").toggleClass("hide");
  }
});

const navBtn = document.getElementById("nav-toggle");
const navbar = document.getElementById("mob-navbar");
// const navClose = document.getElementById("nav-close");
const navLinks = document.getElementById("menu-main");
// show nav
navBtn.addEventListener("click", () => {
  navbar.classList.toggle("showNav");
  navLinks.classList.toggle("showLinks");
  navBtn.classList.toggle("act");
});
// close nav
// navClose.addEventListener("click", () => {
//   navbar.classList.remove("showNav");
//   navLinks.classList.remove("showLinks");
// });

//height
const documentHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty("--doc-height", `jQuery{window.innerHeight}px`);
};
window.addEventListener("resize", documentHeight);
documentHeight();
//for our story
let showMoreText = document.getElementById("moreText");
let buttonText = document.getElementById("readmore");
let story = document.querySelectorAll(".our-story-wrapper");
if (buttonText) {
  buttonText.addEventListener("click", () => {
    if (showMoreText.style.display === "none") {
      showMoreText.style.display = "block";
      story[0].style.minHeight = "1000px";
      buttonText.innerHTML = "Read Less";
      console.log(buttonText);
    } else {
      showMoreText.style.display = "none";
      story[0].style.minHeight = "552px";
      buttonText.innerHTML = "Read More";
    }
  });
}

const accordion = new Accordion();
const accordion2 = new Accordion2();
const slider = new HeroSlider();
